import React from 'react';
import Button from '../button/v2/button';
import Icon from '../icons/icon';
import { HStack } from '../layouts/stack.layout';
import { EffectWrapper } from '../utility/effect-wrapper';

type ReactionsContainerProps = {
  reaction?: 'sad' | 'excited' | 'like' | 'indifferent' | null;
  showReactions: boolean;
  setShowReactions: Function;
};

export default function ReactionsContainer(props: ReactionsContainerProps) {
  const { showReactions, setShowReactions } = props;
  return (
    <HStack
      extensions={showReactions ? 'flex items-center' : 'hidden'}
      justify="between"
    >
      <Button
        onClick={() => setShowReactions(false)}
        asIcon="close"
        color="primary"
        withButtonStyle
        size="base"
      />
      <EffectWrapper
        onClick={() => setShowReactions(false)}
        effect="redish"
        bgColor="#252525"
        extensions="rounded-full p-2 flex justify-center items-center"
      >
        <Icon effect="redish" icon={'like'} size="base" />
      </EffectWrapper>

      <EffectWrapper
        onClick={() => setShowReactions(false)}
        effect="orangish"
        bgColor="#252525"
        extensions="rounded-full p-2 flex justify-center items-center"
      >
        <Icon effect="orangish" icon={'excited'} size="base" />
      </EffectWrapper>

      <EffectWrapper
        onClick={() => setShowReactions(false)}
        effect="blueish"
        bgColor="#252525"
        extensions="rounded-full p-2 flex justify-center items-center"
      >
        <Icon effect="blueish" icon={'sad'} size="base" />
      </EffectWrapper>
      <EffectWrapper
        onClick={() => setShowReactions(false)}
        effect="greenish"
        bgColor="#252525"
        extensions="rounded-full p-2 flex justify-center items-center"
      >
        <Icon effect="greenish" icon={'indifferent'} size="base" />
      </EffectWrapper>
    </HStack>
  );
}
